import React from "react";

import { Button } from "aible";

import NumericLabel from "react-pretty-numbers";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faArrowDown } from "@fortawesome/free-solid-svg-icons";

import RunPlot from "containers/RunPlot/RunPlot";
import ModelTileContainer from "containers/Tiles/ModelTile";
import FeatureChartContainer from "containers/FeatureChart/FeatureChart";
import MiniContainer from "containers/Results/Mini";

import SuccessResults from "components/CreateWizard/Success/SuccessResults";
import DeployStep from "components/CreateWizard/Success/DeployStep";

import AibleStep from "components/CreateWizard/AibleStep";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import ResultsGraph from "components/Results/ResultsGraph";
import ModelError from "components/Results/ModelError";

import ModelLoadingIndicator from "containers/Results/ModelLoadingIndicator";
import MetaDataTable from "components/FeatureChart/MetaDataTable";

import styles from "./style.module.css";

export const SECTIONS = {
  OVERVIEW: "Overview",
  RESULTS: "Results",
  ROI_CHART: "ROI Chart",
  MODEL_PLOTS: "Model Plots",
  PREDICTION_DRIVERS: "Prediction Drivers",
  WHAT_IF: "What If",
  MODEL_DETAILS: "Model Details"
};

export default class AcademicEvaluation extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  generateFids() {
    let ids = this.props.frontierModels && this.props.frontierModels.map((a) => a.id);
    return new Set(ids);
  }

  updateSelectedTab(key) {
    const { updateOption } = this.props;

    return updateOption("selectedTab", key);
  }

  renderROIChart() {
    const { id, models, model } = this.props;

    return (
      <div className={styles.chartHolder}>
        <div className={styles.chartHolder}>
          <RunPlot forceEnableBts hideLineGraphs id={id} />
        </div>
      </div>
    );
  }

  getImpactFromModel(model) {
    const { isContinuous, isQuickRun } = this.props;

    return model
      ? model.maxIteration && model.maxIteration.displayImpact
        ? isContinuous || isQuickRun
          ? Math.abs(Math.round(model.maxIteration.displayImpact))
          : Math.round(model.maxIteration.displayImpact)
        : isContinuous || isQuickRun
          ? Math.abs(Math.round(isQuickRun ? model.meanAbsoluteError : model.checkMax))
          : Math.round(model.checkMax)
      : undefined;
  }

  getUnconstrainedImpactFromModel(model) {
    const { isContinuous, isQuickRun } = this.props;

    return model
      ? model.maxIteration && model.maxIteration.roi
        ? isContinuous || isQuickRun
          ? Math.abs(Math.round(model.maxIteration.roi))
          : Math.round(model.maxIteration.roi)
        : isContinuous || isQuickRun
          ? Math.abs(Math.round(model.maxIteration.checkMax))
          : Math.round(model.checkMax)
      : undefined;
  }

  handleSectionSelect(section) {
    const { model, updateFieldSelect, fieldSelect } = this.props;

    if (section === SECTIONS.PREDICTION_DRIVERS) {
      if (fieldSelect === undefined && model && model.featureInfo && model.featureInfo.length > 0) {
        updateFieldSelect(model.featureInfo[0].label);
      }
    }

    return this.updateSelectedTab(section);
  }

  renderPredictions() {
    const { id, models } = this.props;

    return (
      <div className={styles.chartHolder}>
        <FeatureChartContainer
          id={id}
          label={"Select to see more information about each variable"}
          isResults
          predictMode={"drivers"}
        />
      </div>
    );
  }

  renderWhatIf() {
    const { id, models, projectId } = this.props;

    return (
      <div className={styles.chartHolder}>
        <FeatureChartContainer id={id} isRecommend predictMode={"predict"} projectId={projectId} />
      </div>
    );
  }

  renderDetails() {
    const { id, models, model, frontierModels } = this.props;

    const fids = this.generateFids();

    return <MetaDataTable models={models} fids={fids} {...this.props} />;
  }

  render() {
    const {
      id,
      isNextStep,
      models,
      model,

      options,
      blueprintId,
      isEditBlueprint,
      updateIsNextStep,
      isError,
      errorMessages,
      isFinalStep
    } = this.props;

    const fids = this.generateFids();

    if (isError) {
      return <ModelError errors={errorMessages} />;
    }

    if (models === undefined || model === undefined || models.filter((m) => m.id !== "Current State").length === 0) {
      return blueprintId === "new" || isEditBlueprint ? (
        <div className={styles.emptyMsg}>{"Success page will show here after models are trained"}</div>
      ) : (
        <div className={styles.emptyMsg}>
          <ModelLoadingIndicator id={id} />
        </div>
      );
    }

    const sectionKey = SECTIONS.WHAT_IF;

    let renderFunction;
    switch (sectionKey) {
      case SECTIONS.ROI_CHART:
      case SECTIONS.MODEL_PLOTS:
        renderFunction = () => this.renderROIChart();
        break;
      case SECTIONS.WHAT_IF:
        renderFunction = () => this.renderWhatIf();
        break;
      case SECTIONS.PREDICTION_DRIVERS:
        renderFunction = () => this.renderPredictions();
        break;
      case SECTIONS.MODEL_DETAILS:
        renderFunction = () => this.renderDetails();
        break;
      default:
        renderFunction = () => this.renderPredictions();
    }
    return (
      <div className={styles.results}>
        <div className={styles.resultsContent}>
          {(sectionKey == SECTIONS.MODEL_DETAILS) | sectionKey ? (
            ""
          ) : (
            <div
              className={styles.miniHolder}
              style={
                sectionKey === SECTIONS.PREDICTION_DRIVERS || sectionKey === SECTIONS.WHAT_IF ? { width: "350px" } : {}
              }
            >
              <MiniContainer fids={fids} id={id} section={sectionKey} />
            </div>
          )}
          <div className={styles.rightContent}>{renderFunction && renderFunction()}</div>
        </div>
        {isNextStep !== true && isFinalStep && (
          <div className={sectionKey === SECTIONS.MODEL_DETAILS ? styles.footerNoBar : styles.footer}>
            <Button style={{ marginLeft: "10px" }} type={"primary"} onClick={() => updateIsNextStep(true)}>
              {"Get Predictions"}
            </Button>
          </div>
        )}
        {isNextStep && isFinalStep && <DeployStep {...this.props} />}
      </div>
    );
  }
}
